$(function(){
  alert('slider initializing ...');
  $.ajax({
    url: "/apps/sliderApp/",
  method: "GET",
  dataType: "html",
    success: function(result){
		      alert('Slider will be shown ...');
      console.log(result);
      $('body').append(result);
      $("body, html").animate({
        scrollTop: $(document).height()
      }, 400)
    },error: function(e,d,s){
    	console.log(e,d,s);
    }
  });
})